// extracted by mini-css-extract-plugin
export default {"container":"jvuZnoc7JqOFC5OTq45U"};